import { Component, OnInit } from '@angular/core';
import {ConfService} from '../../conf.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {

  title = 'API Categories';
  cardType = 'categories';
  buttonType = 'category';
  categories: any;
  constructor(private confPost: ConfService) { }

  ngOnInit() {
    this.confPost.getData('services', 'services', 'v1', 'serviceCategories', null).subscribe(response => {
      this.categories = response;
    });
  }

}
